import React from 'react';
import { useNavigate } from 'react-router-dom';

import Button from '../../../components/ui/Button';

const QuickActionCard = ({ title, description, actions }) => {
  const navigate = useNavigate();

  const handleActionClick = (path) => {
    if (path) {
      navigate(path);
    }
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6">
      <div className="mb-4 md:mb-6">
        <h3 className="text-base md:text-lg font-semibold text-foreground mb-1">{title}</h3>
        <p className="text-xs md:text-sm text-muted-foreground">{description}</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
        {actions?.map((action, index) => (
          <Button
            key={index}
            variant={action?.variant || 'outline'}
            iconName={action?.icon}
            iconPosition="left"
            onClick={() => handleActionClick(action?.path)}
            className="justify-start"
          >
            {action?.label}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default QuickActionCard;